"use client";
import { formatDistanceToNow } from "date-fns";
import classes from "./MainSection.module.scss";
import { useRouter } from "next/navigation";
import Image from "next/image";

const MainSection = ({ data }: { data: any }) => {
  const router = useRouter();

  const readMoreClick = (slug: any) => {
    router.push(`/article/${slug}`);
  };

  const slicedData = (data || []).slice(0, 4);

  const [firstArticle, ...restArticles] = slicedData || [];

  return (
    <div className={classes["news-cards-wrapper"]}>
      <div
        className={classes["big-news-container"]}
        onClick={() => readMoreClick(firstArticle?.slug)}
      >
        <div className={classes["big-news-image-container"]}>
          <Image
            src={`${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/${firstArticle?.imageUrl}`}
            alt="Landing Img"
            className={classes["img"]}
            fill
          />
        </div>

        <div className={classes["time-container"]}>
          {firstArticle?.createdAt
            ? formatDistanceToNow(new Date(firstArticle?.createdAt)) + " ago"
            : "Unknown time"}
        </div>

        <p className={classes["news-header"]}>{firstArticle?.title}</p>
        <p className={classes["news-desc"]}>{firstArticle?.postExcerpt}</p>

        <div className={classes["news-category"]}>
          <div className={classes["category-wrapper"]}>
            <p> {firstArticle?.categoryName}</p>
          </div>
        </div>
      </div>

      <div className={classes["side-news-container"]}>
        {restArticles.map((article: any, index: number) => (
          <div
            key={index}
            className={classes["news-container"]}
            onClick={() => readMoreClick(article?.slug)}
          >
            <div className={classes["news-image-container"]}>
              <Image
                src={`${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/${article?.imageUrl}`}
                alt="Landing Img"
                className={classes["small-img"]}
                fill
              />
            </div>

            <div className={classes["news-content-container"]}>
              <div className={classes["time-container"]}>
                {article?.createdAt
                  ? formatDistanceToNow(new Date(article.createdAt)) + " ago"
                  : "Unknown time"}
              </div>

              <p className={classes["news-header"]}>{article?.title}</p>
              <p className={classes["news-desc"]}>{article?.postExcerpt}</p>

              <div className={classes["news-category"]}>
                <div className={classes["category-wrapper"]}>
                  <p> {article?.categoryName}</p>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MainSection;
